export default __webpack_public_path__ + "static/media/payroll-feature-multiple-pay-structure.6013be79.svg";